const getUserName = () => {
  return localStorage.getItem("userName");
};

const setUserName = name => {
  return localStorage.setItem("userName", name);
};

const getUserPhoto = () => {
  return localStorage.getItem("userPhoto");
};

const setUserPhoto = photo => {
  return localStorage.setItem("userPhoto", photo);
};

const getSchoolName = () => {
  const stored = localStorage.getItem("userSchoolName");
  if (stored && String(stored).trim()) return String(stored).trim();

  try {
    const campuses = JSON.parse(
      localStorage.getItem("availableCampuses") || "null"
    );
    const currentId = localStorage.getItem("currentCampus");
    const list = Array.isArray(campuses) ? campuses : [];
    const current =
      list.find(
        c => c && c.Campus && String(c.Campus.id) === String(currentId)
      ) || list[0];
    const campusName =
      current &&
      current.Campus &&
      (current.Campus.name || current.Campus.nome || current.Campus.NOME);
    if (campusName && String(campusName).trim()) {
      return String(campusName).trim();
    }
  } catch (e) {
    /* ignore */
  }

  return "Colégio Waybee";
};

const setSchoolName = name => {
  if (name == null || name === "") {
    localStorage.removeItem("userSchoolName");
    return null;
  }
  localStorage.setItem("userSchoolName", String(name));
  return String(name);
};

const getToken = () => {
  return localStorage.getItem("token");
};

const setToken = value => {
  localStorage.setItem("token", value);
};

const setAvailableCampus = campus => {
  localStorage.setItem("availableCampuses", JSON.stringify(campus));
};

const getAvailableCampus = () => {
  try {
    const raw = localStorage.getItem("availableCampuses");
    if (!raw || raw === "null") return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    return [];
  }
};

const setCurrentCampus = val => {
  localStorage.setItem("currentCampus", val);
};

const getCurrentCampus = () => {
  return localStorage.getItem("currentCampus");
};

const getUserExternalId = () => {
  return localStorage.getItem("externalId");
};

const setUserExternalId = id => {
  return localStorage.setItem("externalId", id);
};

const getUserExternalInfo = () => {
  return JSON.parse(localStorage.getItem("userExternalInfo"));
};

const setUserExternalInfo = data => {
  return localStorage.setItem("userExternalInfo", JSON.stringify(data));
};

const getCodFilial = () => {
  return localStorage.getItem("codFilial");
};

const getCodColigada = () => {
  return localStorage.getItem("codColigada");
};

const getAnoLetivo = () => {
  const fromEnv = process.env.REACT_APP_ANO_LETIVO;
  if (fromEnv) return Number(fromEnv) || fromEnv;
  if (
    typeof window !== "undefined" &&
    /band\.diario-homolog/.test(window.location.hostname)
  ) {
    return 2024;
  }
  return new Date().getFullYear();
};

const clear = () => {
  localStorage.clear();
};

const UserStore = {
  getUserName,
  setUserName,
  getUserPhoto,
  setUserPhoto,
  getSchoolName,
  setSchoolName,
  getToken,
  setToken,
  getAvailableCampus,
  setAvailableCampus,
  getCurrentCampus,
  setCurrentCampus,
  getUserExternalId,
  setUserExternalId,
  getUserExternalInfo,
  setUserExternalInfo,
  getCodColigada,
  getCodFilial,
  getAnoLetivo,
  clear
};

export default UserStore;
